/* (c) Copyright 2020 Pivotal Software, Inc. All Rights Reserved. */
"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var scrollbarWidth;
var DomHelpers = {
  documentExists: function documentExists() {
    return typeof global.document !== 'undefined';
  },
  getActiveElement: function getActiveElement() {
    return global.document.activeElement;
  },
  setTimeout: function setTimeout(handler, timeout) {
    return global.setTimeout(handler, timeout);
  },
  clearTimeout: function clearTimeout(handler) {
    return global.clearTimeout(handler);
  },
  resetScrollbarWidth: function resetScrollbarWidth() {
    return scrollbarWidth = undefined;
  },
  findTabbableElements: function findTabbableElements(el) {
    return el && el.querySelectorAll('[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex]:not([tabindex="-1"])');
  },
  getScrollbarWidth: function getScrollbarWidth(document) {
    if (scrollbarWidth) return scrollbarWidth;
    if (!document) return 0;
    var scrollDiv = document.createElement('div');
    scrollDiv.style.width = '100px';
    scrollDiv.style.height = '100px';
    scrollDiv.style.overflow = 'scroll';
    scrollDiv.style.position = 'absolute';
    scrollDiv.style.top = '-9999px';
    document.body.appendChild(scrollDiv);
    scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
    document.body.removeChild(scrollDiv);
    return scrollbarWidth;
  },
  disableBodyScrolling: function disableBodyScrolling(document) {
    if (!document) return {};
    var overflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return overflow;
  },
  enableBodyScrolling: function enableBodyScrolling(_ref) {
    var overflow = _ref.overflow,
        document = _ref.document;
    if (!document) return;
    document.body.style.overflow = overflow;
  }
};
var _default = DomHelpers;
exports["default"] = _default;